import { render, staticRenderFns } from "./ModalConfirmRegularUpdate.vue?vue&type=template&id=1d6662da&scoped=true&"
import script from "./ModalConfirmRegularUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmRegularUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6662da",
  null
  
)

export default component.exports